import { useParams } from "react-router-dom";
import { getTerminalGroup } from "@/data/airlineTerminals";
import AirlineTerminal from "./AirlineTerminal";
import TerminalDetail from "./TerminalDetail";

/**
 * /airports/:code/terminals/:slug serves two page types:
 *  - airline pages   e.g. /airports/jfk/terminals/delta
 *  - terminal pages  e.g. /airports/jfk/terminals/terminal-8
 * Terminal slugs are checked first; anything else falls through to the
 * existing airline page (which renders NotFound for unknown slugs).
 */
const TerminalRoute = () => {
  const { code, airline: slug } = useParams<{ code: string; airline: string }>();
  const isTerminal = Boolean(getTerminalGroup(code, slug));
  return isTerminal ? <TerminalDetail /> : <AirlineTerminal />;
};

export default TerminalRoute;
